import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import EnvRibbon from "./components/layout/EnvRibbon";
import "./index.css";
import "./styles/hero-animations.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <EnvRibbon />
    <App />
  </React.StrictMode>
);
